import { Component } from "@opten/compiler/metadata/component";

@Component({ className: "js-form" })
export class FormComponent {
	constructor(private form: HTMLFormElement) {
		this.form.addEventListener("submit", () => this.disableSubmitButtons());
	}

	private disableSubmitButtons(): void {
		const submitButtons = this.form.querySelectorAll('button[type="submit"]');
		submitButtons.forEach((button: Element) => {
			(button as HTMLButtonElement).disabled = true;
		});
	}
}
